import React from 'react';
import { MapPin, Phone, Mail,} from 'lucide-react';
import '../footer.css';

const Footer = () => {
    return (
    <footer className="main-footer">
        <div className="footer-top">
        {/* Brand Column */}
        <div className="footer-col brand-col">
            <div className="footer-logo">
            <img src="./images/dlc_transparent.png" alt='Logo' ></img>
            </div>
            <p>Building dreams with design and innovation. Your trusted partner in custom home construction.</p>
        </div>

        {/* Quick Links Column */}
        <div className="footer-col">
            <h3>Quick Links</h3>
            <ul>
            <li><a href="/test">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/service">Services</a></li>
            <li><a href="/portfolio">Portfolio</a></li>
            </ul>
        </div>

        {/* Contact Column */}
        <div className="footer-col">
            <h3>Contact Us</h3>
            <div className="contact-info">
            <div className="info-item">
                <MapPin size={18} className="icon" />
                <span>Chicago, Illinois</span>
            </div>
            <div className="info-item">
                <Phone size={18} className="icon" />
                <span>(708) 595-1156</span>
            </div>
            <div className="info-item">
                <Mail size={18} className="icon" />
                <span>dlchomebuilders@outlook.com</span>
            </div>
            </div>
        </div>

        {/* Follow & Hours Column */}
        <div className="footer-col">
            {/* <h3>Follow Us</h3>
            <div className="social-icons">
            <a href="#"><Facebook size={20} /></a>
            <a href="#"><Instagram size={20} /></a>
            <a href="#"><Linkedin size={20} /></a>
            </div> */}
            <div className="business-hours">
            <h3>Business Hours</h3>
            <p>Monday - Friday: 8AM - 6PM</p>
            <p>Saturday: 9AM - 4PM</p>
            <p>Sunday: Closed</p>
            </div>
        </div>
        </div>

        <div className="footer-bottom">
        <p>© 2026 DLC Home Builders. All rights reserved. Design & Innovation - Building Your Dreams.</p>
        </div>
    </footer>
    );
};

export default Footer;